var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "swiper" } }, [
    _c(
      "div",
      { staticClass: "swipe-parent" },
      [
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.swipeList.length,
              expression: "swipeList.length"
            }
          ],
          staticClass: "swiper-button-prev",
          style: _vm.swiperButtonPrev,
          attrs: { slot: "button-prev" },
          slot: "button-prev"
        }),
        _vm._v(" "),
        _c(
          "swiper",
          { ref: "mySwiper", attrs: { options: _vm.swiperOptions } },
          _vm._l(_vm.swipeList, function(page, pageIdx) {
            return _c("swiper-slide", { key: "swipe-page" + pageIdx }, [
              _c("div", { staticClass: "swipe_image" }, [
                _c("img", {
                  attrs: { src: page.img },
                  on: {
                    click: function($event) {
                      _vm.$emit("clickImage", page)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "swipe_info" }, [
                _c("div", { staticClass: "swipe_info_title" }, [
                  _vm._v(_vm._s(page.name))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "swipe_info_size" }, [
                  _vm._v(_vm._s(page.size))
                ])
              ])
            ])
          })
        ),
        _vm._v(" "),
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.swipeList.length,
              expression: "swipeList.length"
            }
          ],
          staticClass: "swiper-button-next",
          style: _vm.swiperButtonNext,
          attrs: { slot: "button-next" },
          slot: "button-next"
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44f2404a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44f2404a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/components/common/DcProductSwiper.vue
// module id = null
// module chunks = 